<template>
    <section id="testi">
        <div class="container-fluid py-5">
            <div class="col-12 w-title text-center margin-title-testi">
                <h3 class="text-title-content text-secondary text-uppercase wow slideInDown">{{ SectionTesti.title }}</h3>
            </div>
            <div class="row">
                <div class="col-lg-12 grid-margin stretch-card px-0">
                    <div class="card border-0 bg-transparent padding">
                        <div class="card-body">
                            <div class="owl-carousel owl-theme owl-loaded">
                                <div class="item testimonial">
                                    <blockquote>
                                        {{ SectionTesti.testi01 }}
                                        <p>{{ SectionTesti.testi01Name }}</p>
                                    </blockquote>
                                </div>
                                <div class="item testimonial">
                                    <blockquote>
                                        {{ SectionTesti.testi02 }}
                                        <p>{{ SectionTesti.testi02Name }}</p>
                                    </blockquote>
                                </div>
                                <div class="item testimonial">
                                    <blockquote>
                                        {{ SectionTesti.testi03 }}
                                        <p>{{ SectionTesti.testi03Name }}</p>
                                    </blockquote>
                                </div>
                                <div class="item testimonial">
                                    <blockquote>
                                        {{ SectionTesti.testi04 }}
                                        <p>{{ SectionTesti.testi04Name }}</p>
                                    </blockquote>
                                </div>
                                <div class="item testimonial">
                                    <blockquote>
                                        {{ SectionTesti.testi05 }}
                                        <p>{{ SectionTesti.testi05Name }}</p>
                                    </blockquote>
                                </div>
                                <div class="item testimonial">
                                    <blockquote>
                                        {{ SectionTesti.testi06 }}
                                        <p>{{ SectionTesti.testi06Name }}</p>
                                    </blockquote>
                                </div>
                                <div class="item testimonial">
                                    <blockquote>
                                        {{ SectionTesti.testi07 }}
                                        <p>{{ SectionTesti.testi07Name }}</p>
                                    </blockquote>
                                </div>
                                <div class="item testimonial">
                                    <blockquote>
                                        {{ SectionTesti.testi08 }}
                                        <p>{{ SectionTesti.testi08Name }}</p>
                                    </blockquote>
                                </div>
                                <div class="item testimonial">
                                    <blockquote>
                                        {{ SectionTesti.testi09 }}
                                        <p>{{ SectionTesti.testi09Name }}</p>
                                    </blockquote>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="col-lg-12 grid-margin stretch-card px-0">
                    <Hooper class="slider-hooper" :settings="hooperSettings" :infiniteScroll="true" :mouseDrag="true" :wheelControl="false" :autoPlay="false" :playSpeed="5000" :transition="1000">
                        <Slide>
                            <div class="testimonial">
                                <blockquote>
                                    <img class="img-testi" src="assets/img/testi1.jpg">
                                    <h8>{{ SectionTesti.testi01 }}</h8>
                                    <p>{{ SectionTesti.testi01Name }}</p>
                                </blockquote>
                            </div>
                        </Slide>
                        <Slide>
                            <div class="testimonial">
                                <blockquote>
                                    <img class="img-testi" src="assets/img/testi2.jpg">
                                    {{ SectionTesti.testi02 }}
                                    <p>{{ SectionTesti.testi02Name }}</p>
                                </blockquote>
                            </div>
                        </Slide>
                        <Slide>
                            <div class="testimonial">
                                <blockquote>
                                    <img class="img-testi" src="assets/img/testi3.jpg">
                                    {{ SectionTesti.testi03 }}
                                    <p>{{ SectionTesti.testi03Name }}</p>
                                </blockquote>
                            </div>
                        </Slide>
                        <Slide>
                            <div class="testimonial">
                                <blockquote>
                                    <img class="img-testi" src="assets/img/testi4.jpg">
                                    {{ SectionTesti.testi04 }}
                                    <p>{{ SectionTesti.testi04Name }}</p>
                                </blockquote>
                            </div>
                        </Slide>
                        <Slide>
                            <div class="testimonial">
                                <blockquote>
                                    <img class="img-testi" src="assets/img/testi5.jpg">
                                    {{ SectionTesti.testi05 }}
                                    <p>{{ SectionTesti.testi05Name }}</p>
                                </blockquote>
                            </div>
                        </Slide>
                        <Slide>
                            <div class="testimonial">
                                <blockquote>
                                    <img class="img-testi" src="assets/img/testi6.jpg">
                                    {{ SectionTesti.testi06 }}
                                    <p>{{ SectionTesti.testi06Name }}</p>
                                </blockquote>
                            </div>
                        </Slide>
                        <Slide>
                            <div class="testimonial">
                                <blockquote>
                                    <img class="img-testi" src="assets/img/testi7.jpg">
                                    {{ SectionTesti.testi07 }}
                                    <p>{{ SectionTesti.testi06Name }}</p>
                                </blockquote>
                            </div>
                        </Slide>
                        <Slide>
                            <div class="testimonial">
                                <blockquote>
                                    <img class="img-testi" src="assets/img/testi8.jpg">
                                    {{ SectionTesti.testi08 }}
                                    <p>{{ SectionTesti.testi08Name }}</p>
                                </blockquote>
                            </div>
                        </Slide>
                        <Slide>
                            <div class="testimonial">
                                <blockquote>
                                    <img class="img-testi" src="assets/img/testi9.jpg">
                                    {{ SectionTesti.testi09 }}
                                    <p>{{ SectionTesti.testi09Name }}</p>
                                </blockquote>
                            </div>
                        </Slide>
                        <template #hooper-addons>
                        <Navigation></Navigation>
                        <Pagination />
                        </template>
                    </Hooper>
                </div> -->
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios'
// import { Hooper, Slide, Navigation, Pagination } from '@wattanx/hooper-vue3';
// import '@wattanx/hooper-vue3/css';

export default {
    name: 'SectionTesti',
    components:{
        // Hooper,
        // Slide,
        // Navigation,
        // Pagination
    },
    data() {
        return {
            lastScrollPosition: 0,
            SectionTesti: {
                title: null,
                testi01: null,
                testi01Name: null,
                testi02: null,
                testi02Name: null,
                testi03: null,
                testi03Name: null,
                testi04: null,
                testi04Name: null,
                testi05: null,
                testi05Name: null,
                testi06: null,
                testi06Name: null,
                testi07: null,
                testi07Name: null,
                testi08: null,
                testi08Name: null,
                testi09: null,
                testi09Name: null,
                wa: null
            },
            hooperSettings: {
                itemsToShow: 3,
                centerMode: true,
                breakpoints: {
                    0: {
                        itemsToShow: 1,
                        itemsToSlide: 1
                    },
                    600: {
                        itemsToShow: 2,
                        itemsToSlide: 2
                    },
                    1000: {
                        itemsToShow: 3,
                        itemsToSlide: 3
                    }
                }
            }
        }
    },

    mounted() {
        axios.get(`../../lang.json`).then(response => {
            let dataSectionTesti
            if (localStorage.getItem('lang_nad') == 'id') {
                dataSectionTesti = response.data.id[0];
            } else if (localStorage.getItem('lang_nad') == 'en') {
                dataSectionTesti = response.data.en[0];
            }
            this.SectionTesti.title = dataSectionTesti.SectionTesti.title
            this.SectionTesti.testi01 = dataSectionTesti.SectionTesti.testi01
            this.SectionTesti.testi01Name = dataSectionTesti.SectionTesti.testi01Name
            this.SectionTesti.testi02 = dataSectionTesti.SectionTesti.testi02
            this.SectionTesti.testi02Name = dataSectionTesti.SectionTesti.testi02Name
            this.SectionTesti.testi03 = dataSectionTesti.SectionTesti.testi03
            this.SectionTesti.testi03Name = dataSectionTesti.SectionTesti.testi03Name
            this.SectionTesti.testi04 = dataSectionTesti.SectionTesti.testi04
            this.SectionTesti.testi04Name = dataSectionTesti.SectionTesti.testi04Name
            this.SectionTesti.testi05 = dataSectionTesti.SectionTesti.testi05
            this.SectionTesti.testi05Name = dataSectionTesti.SectionTesti.testi05Name
            this.SectionTesti.testi06 = dataSectionTesti.SectionTesti.testi06
            this.SectionTesti.testi06Name = dataSectionTesti.SectionTesti.testi06Name
            this.SectionTesti.testi07 = dataSectionTesti.SectionTesti.testi04
            this.SectionTesti.testi07Name = dataSectionTesti.SectionTesti.testi04Name
            this.SectionTesti.testi08 = dataSectionTesti.SectionTesti.testi05
            this.SectionTesti.testi08Name = dataSectionTesti.SectionTesti.testi05Name
            this.SectionTesti.testi09 = dataSectionTesti.SectionTesti.testi06
            this.SectionTesti.testi09Name = dataSectionTesti.SectionTesti.testi06Name
            this.SectionTesti.wa = dataSectionTesti.SectionTesti.wa
        })

        window.addEventListener('scroll', this.onScroll)
    }
}
</script>
